export default {
    tableName: "termsandconditionstypes",
  
    attributes: {
      name: {
        type: "string",
        required: true,
      },
  
      icon: {
        type: "string",
        required: true,
      },
  
      termsandconditions: {
        collection: 'termsandconditions',
        via: 'type'
      },
    },
  };
  


// WEBPACK FOOTER //
// ./src/models/TermsAndConditionsTypes.js